import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { FormApplicationNotificationsEditView } from './views/FormApplicationNotificationsEditView';
import { FormApplicationNotificationsInteractions } from './partials/FormApplicationNotificationsInteractions';
import { FormApplicationNotificationsDefaultView } from './views/FormApplicationNotificationsDefaultView';

export type FormApplicationNotificationsProps = Views<
  DefaultView<FormApplicationNotificationsDefaultView> & EditView<FormApplicationNotificationsEditView>
>;

function FormApplicationNotifications(props: FormApplicationNotificationsProps) {
  return <FormApplicationNotificationsInteractions {...props} />;
}

export const FormApplicationNotificationsBlock = asFetchableBlock(
  FormApplicationNotifications,
  BlockType.formapplicationNotifications,
);
export type FormApplicationNotificationsBlock = ComponentProps<typeof FormApplicationNotifications>;
